_ = require 'underscore'
Dates = require 'lib/dates'
Util = require 'lib/util'
View = require 'view'
moment = require 'moment'
template = require 'views/templates/header_warning_aa_domain_claimed'
Storage = require 'lib/session-storage'

module.exports = class AaDomainClaimBannerView extends View
  SNOOZED_STORAGE_KEY = 'aa-banner-snoozed'

  className: 'header-banner'

  constructor: ({ @enterprise, @onChange }) ->
    super

  events:
    'click .js-dismiss-aa-domain-claimed': 'dismiss'

  dismiss: (e) ->
    Util.stop(e)
    @snooze()

  render: ->
    @$el.html(
      template(
        orgName: @enterprise.get('displayName')
        domain: @model.getAaDomain()
      )
    )
    @

  isSnoozed: ->
    snoozed = Storage.get(SNOOZED_STORAGE_KEY)
    return snoozed && moment().isBefore(snoozed.expires)

  snooze: ->
    Storage.set SNOOZED_STORAGE_KEY,
      expires: moment().add(1, 'days').set
        hour: 4
        minute: 0
        second: 0
    @remove()



// WEBPACK FOOTER //
// ./app/scripts/views/header/aa-domain-claim-banner-view.coffee